import { Box } from "@mui/material";
import SvgToIcon from "../icons/SvgToIcon";
import { icons } from "../scenes/stack/environment/icons/iconExport";

const ArrowInstruction = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap={1}
      paddingTop="10px"
      paddingBottom="10px"
    >
      <SvgToIcon IconLogo={icons.arrow} width="18px" />
      {children}
    </Box>
  );
};

export default ArrowInstruction;
